import { createFileRoute, redirect } from "@tanstack/react-router";
import { getAssetScopedRecordWorkspacePath } from "@/features/jobs/lib/get-asset-workspace-path.util";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/assets/$assetId/workspace/records/$recordId/workspace/",
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			href: getAssetScopedRecordWorkspacePath({
				orgId: params.orgId,
				jobId: params.jobId,
				assetId: params.assetId,
				recordId: params.recordId,
				tab: "form",
			}),
		});
	},
});
